//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhotoSwipe from 'photoswipe/dist/photoswipe'
import UI from 'photoswipe/dist/photoswipe-ui-default'
import objectAssign from 'object-assign'

import $ from 'jquery'

export default {
  data() {
    return {
      current: 0,
      showPositionValue: false,
      position: 'default',
      img_list: []
    }
  },
  methods: {

    init() {
      const self = this
      this._init(0)
    },
    _init(index) {
      const self = this
      let options = objectAssign({
        history: false,
        shareEl: false,
        tapToClose: false,
        index: index
      }, this.options)
      this.photoswipe = new PhotoSwipe(this.$el, UI, this.img_list, options)

      this.photoswipe.init()
      this.photoswipe.listen('close', () => {
        this.$emit('on-close')
      })
    },
    showPosition(position) {
      this.position = position
      this.showPositionValue = true
    },
    show(item) {
      this.img_list = []
      this.img_list.push({
        w: item.w,
        h: item.h,
        src: item.src + '?imageMogr2/auto-orient'
      })
      this.init()
    },
    close() {
      this.photoswipe.close()
    }
  },
  props: [
    'list',
    'index',
    'options'
  ],
}



// WEBPACK FOOTER //
// ./src/components/XPreview/XPreview.vue